const PDF_VIEWER_PARAMS = "#toolbar=0&navpanes=0&scrollbar=0";

export function cgmInfoPdfSrc(baseUrl: string): string {
  return `${baseUrl}${PDF_VIEWER_PARAMS}`;
}
